import _Promise from 'babel-runtime/core-js/promise';
import Loading from '@xunlei/thunder-ui-vue/lib/loading.js';

var loading = {
  install: function install(Vue) {
    Vue.directive('loading', {
      bind: function bind(el, _ref, VNode) {
        var value = _ref.value;

        var vm = VNode.context.$loadingInstance = new Vue({
          el: el.appendChild(document.createElement('div')),
          components: {
            TdLoading: Loading
          },
          data: {
            loading: false,
            text: ''
          },
          render: function render(createElement) {
            return createElement('td-loading', {
              props: {
                loading: this.loading,
                text: this.text
              }
            });
          }
        });

        if (typeof value === 'boolean' || value instanceof _Promise) {
          vm.loading = value;
        } else {
          vm.loading = value.loading;
          vm.text = value.text;
        }
      },
      update: function update(el, _ref2, VNode) {
        var value = _ref2.value;

        var vm = VNode.context.$loadingInstance;

        if (typeof value === 'boolean' || value instanceof _Promise) {
          vm.loading = value;
          vm.text = '';
        } else {
          vm.loading = value.loading;
          vm.text = value.text;
        }
      }
    });
  }
};

export default loading;
